import { SocketEvent } from '@/services/ws/core/event'
import { EVENTS } from '@/components/Bonuses/constants'

class FsBonusActivatedEvent extends SocketEvent {
  async handle(_data, { }) {
    window.$nuxt.$emit(EVENTS.FS_BONUS_ACTIVATED)
  }
}

export const fsBonusActivatedEvent = new FsBonusActivatedEvent()
